const UseRef = () => {
    return (
        <div className="demo-container">
            <div className="demo-box" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                <div className='lead'>Has already been used in Forward Refs. Check evernote for further details on the hook.</div></div>
        </div>
    )
}

export default UseRef